import { Fragment, ReactNode, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSomaAuth } from "./SomaAuthContext";
import { AppDispatch, RootState } from "../app/Store";
import { applicationSessionChanged } from "../app/store/GlobalActions";

export default function ApplicationSessionBoundary({ children }: { children: ReactNode }) {
  const { currentAccount, currentLocalUser, isLocalAuthEnabled } = useSomaAuth();
  const dispatch = useDispatch<AppDispatch>();
  const identityKey = isLocalAuthEnabled
    ? currentLocalUser
      ? `local:${currentLocalUser.objectId}`
      : null
    : currentAccount
      ? `msal:${currentAccount.homeAccountId}`
      : null;
  const selectedIdentity = useSelector((state: RootState) => state.session.identityKey);
  useLayoutEffect(() => {
    dispatch(applicationSessionChanged({ identityKey }));
  }, [dispatch, identityKey]);

  return identityKey !== null && identityKey === selectedIdentity ? (
    <Fragment key={identityKey}>{children}</Fragment>
  ) : null;
}
